import React from "react";
import Router from "./navigation/Router";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import PartsDiagramPage from "./screens/PartsDiagramPage";
import InvoiceScreen from "./screens/InvoiceScreen";




function App() {
  return (
    <div style={styles.app}>

      {/* soft light layer */}
      <div style={styles.light}></div>

      {/* glass blur layer */}
      <div style={styles.blur}></div>

      {/* content */}
      <div style={styles.content}>
        <Router />
      </div>

    </div>
  );
}

export default App;

const styles = {

  app: {
  minHeight: "100vh",
  background: "#F2F2F7",
  position: "relative",
  overflowX: "hidden",
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, system-ui, sans-serif"
},

  light: {
    position: "fixed",
    top: "-20%",
    left: "-10%",
    width: "120%",
    height: "120%",
    background:
      "radial-gradient(circle at 30% 20%, rgba(255,255,255,0.9), transparent 60%)",
    zIndex: 0
  },

  blur: {
    position: "fixed",
    inset: 0,
    backdropFilter: "blur(40px)",
    WebkitBackdropFilter: "blur(40px)",
    background: "rgba(255,255,255,0.35)",
    pointerEvents: "none",
    zIndex: 1
  },

  content: {
    position: "relative",
    zIndex: 2
  }

};